var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"readonly":"","label":_vm.label,"dense":_vm.tce.dense},model:{value:(_vm.valore),callback:function ($$v) {_vm.valore=$$v},expression:"valore"}})
}
var staticRenderFns = []

export { render, staticRenderFns }